var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M36.303 19.369 23.612 33.198a1.5 1.5 0 0 1-1.073.485h-.033c-.396 0-.778-.157-1.059-.438l-5.65-5.638a1.5 1.5 0 0 1 2.119-2.123l4.542 4.532L34.092 17.34a1.501 1.501 0 0 1 2.211 2.029M25.278 0C11.317 0 0 11.318 0 25.279s11.317 25.278 25.278 25.278S50.556 39.24 50.556 25.279 39.239 0 25.278 0"
  })));
};
export default SvgCheckmark;